export default "__VITE_ASSET__BruWukZ5__"